<template>
    <transition name="slide-fade">
        <div class="landing-page-menu-container faux-fixed" v-if="showSubMenu">
            <router-link
                v-for="page in pages"
                :to="page.href"
                :key="page.title"
                class="landing-page-menu-button stay-black"
                :class="{ active: page.number == currentPage }"
            >
                {{ page.title }}
            </router-link>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            mainMenuOpen: "menu/menuOpen",
        }),
        pages() {
            const { meta } = this.$route;
            return meta && meta.pages;
        },
        currentPage() {
            const { path } = this.$route;
            const currentPageObj =
                this.pages && this.pages.find((page) => page.href == path);
            return currentPageObj && currentPageObj.number;
        },
        showSubMenu() {
            return this.pages && this.pages.length > 0 && !this.mainMenuOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
    margin-top: -40px;
    opacity: 0;
}
.landing-page-menu-container {
    width: 100%;
    white-space: nowrap;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    background: #fff;
    z-index: 99;
    position: relative;
    .landing-page-menu-button {
        white-space: normal;
        width: 50%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        display: inline-block;
        font-size: 14px;
        position: relative;
        &.active {
            font-weight: 700;
            &:after {
                content: "";
                position: absolute;
                display: block;
                bottom: 0;
                height: 2px;
                background: #f2c0de;
                width: 100%;
            }
        }
    }
    &.hasFilterButton {
        .landing-page-menu-button {
            width: calc(50% - 17px);
        }
    }
}
</style>
